<template>
    <BaseLayout gap="none" fill-height no-top-padding content-class="items-center pt-[8vh] md:pt-[15vh]">
        <PerspectiveIntroCard
            :has-in-progress-session="props.has_in_progress_session"
            :is-starting="isStartingAssessment"
            :error-message="startAssessmentErrorMessage"
            :collaboration-profile-enabled="props.collaboration_profile_enabled"
            @start="handleStartAssessment"
            @continue="handleContinueAssessment" />
        <PerspectiveDemoTools />
    </BaseLayout>
</template>

<script lang="ts">
import LeftSidebarLayout from "~vue/layouts/LeftSidebarLayout.vue";
export default { layout: LeftSidebarLayout };
</script>

<script setup lang="ts">
import BaseLayout from "~vue/components/BaseLayout.vue";
import { usePerspective } from "~vue/Perspective/composable/usePerspective";
import PerspectiveDemoTools from "~vue/Perspective/PerspectiveDemoTools.vue";
import PerspectiveIntroCard from "~vue/UserProfile/PerspectiveIntroCard.vue";

export interface Props {
    has_in_progress_session: boolean;
    collaboration_profile_enabled: boolean;
}

const props = defineProps<Props>();

const { handleStartAssessment, handleContinueAssessment, isStartingAssessment, startAssessmentErrorMessage } = usePerspective({ source: "perspective_assessment" });
</script>
